

export class TranslationConfig{

    /**
     *
     * Don't define translation strings everywhere in the client.
     * Use something like this to make it easier for both you and the translator for defining what text is being used.
     *
     *
    */

   public static BANNER_WAYS:string = "Win ways";

   public static SIDE_COUNTER_WAYS:string = "Ways";
   public static WIN_UP_TO:string = "WIN UP TO";


    // WIN, number of XWays
    public static WAYS_WON:string = "Ways Won";
    public static WAY_WON:string = "Way Won";


    // OUTRO TOTAL WIN
    public static TOTAL_WIN:string = "TOTAL WIN";

    // OVERALL PRESENTATIONS
    // INTRO VIEW
    public static LAST_SPIN = "LAST SPIN!!!";
    public static FREESPINS:string = "SPINS";
    public static FREESPINS_PLAYED:string = "SPINS PLAYED:";
    public static FREESPINS_LEFT:string = "SPINS LEFT";

    public static JUMPING_WILDS:string = "JUMPING WILDS";
    public static COLLECT:string = "COLLECT";
    public static COLLECTED:string = "COLLECTED";

    public static COLLECTED_JUMPING_WILDS_IMPOSSIBLE:string = "COLLECT (impossible to get) JUMPING WILDS";
    public static COLLECTED_JUMPING_WILDS:string = "COLLECT JUMPING WILDS";

    // BUTTON TEXT
    public static LOADING:string = "LOADING";
    public static CONTINUE:string = "CONTINUE";
    public static BEGIN:string = "BEGIN";

    // INTRO VIEW
    public static PRODUCTION_A:string = "A ";
    /* Production Name */
    public static PRODUCTION:string = " PRODUCTION";



}
